<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-lg navbar-light bg-white" id="sidenav-main">
        <div class="container-fluid">
            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar" class="border">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>
            <router-link class="hidden-custom navbar-brand d-flex align-items-center justify-content-center" to="/">
              <div><img :src="logo" width="45" height="auto" alt="chatbot logo"></div>
              <div class="ml-2 mt-auto mb-auto text-logo"><span>uniBot</span></div>
            </router-link>
            <slot name="mobile-right">
                <ul class="nav align-items-center d-md-none">
                  <language-dropdown class="nav-item dropdown mr-1" :isLabel="false" />
                  <user-info-dropdown class="nav-item dropdown" />
                </ul>
            </slot>
            <slot></slot>
            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">
                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link class="d-flex" to="/">
                                <div><img :src="logo" width="45" height="auto" alt="chatbot logo"></div>
                                <div class="ml-2 mt-auto mb-auto text-logo"><span>uniBot</span></div>
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script>
import NavbarToggleButton from '@/components/template/NavbarToggleButton'
import LanguageDropdown from '@/components/LanguageDropdown'
import UserInfoDropdown from '@/components/UserInfoDropdown'

export default {
  name: 'sidebar',
  components: {
    NavbarToggleButton,
    LanguageDropdown,
    UserInfoDropdown
  },
  props: {
    logo: {
      type: String,
      default: '/static/img/icons/bot_icon.gif',
      description: 'Sidebar app logo'
    },
    autoClose: {
      type: Boolean,
      default: true,
      description: 'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  data () {
    return {
      sidebarDisplayed: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.getSidebarVal())
    },
    showSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.getSidebarVal())
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/template/SidebarPlugin/SideBar.vue